<template>
  <div>
    <div class="page-header">
      <h3>Anytime Items</h3>
    </div>
    <TaskExpander />
    <NewQuickTask />

    <ul class="mt-2 list-group">
      <li v-for="task in allTasks()" :key="task.id" class="list-group-item js-task-details-collapse-container" v-bind:class="{ 'bg-light': task.kind == 'comment' }">
        <QuickTask :task="task"/>
      </li>
    </ul>
    
  </div>
</template>

<script>
import QuickTask from "components/QuickTask";
import NewQuickTask from "components/NewQuickTask";
import TaskExpander from "components/TaskExpander";

export default {
  components: {
    QuickTask,
    NewQuickTask,
    TaskExpander
  },
  computed: {
    projectAreas: {
      get() {
          return this.$store.state.project_areas
      }
    }
  },
  methods: {
    projectTasks: function(project_id){
      return this.$store.state.tasks.filter(function (task){
        return (task.project_id == project_id && (task.completed === false && task.journaled === false))
      })
      .sort(function(a, b) {
        return new Date(b.created_at) - new Date(a.created_at);
      });
    },
    allTasks: function(){
      return this.$store.state.tasks.filter(function (task){
        return (task.completed === false && task.journaled === false)
      })
      .sort(function(a, b) {
        return new Date(b.updated_at) - new Date(a.updated_at);
      });      
    }
  }
};
</script>
